/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Outcomes in one time slot of a health window.
 * @export
 * @interface HealthBucket
 */
export interface HealthBucket {
    /**
     * 
     * @type {number}
     * @memberof HealthBucket
     */
    error: number;
    /**
     * 
     * @type {number}
     * @memberof HealthBucket
     */
    total: number;
    /**
     * Start of the time slot.
     * @type {Date}
     * @memberof HealthBucket
     */
    start: Date;
}

/**
 * Check if a given object implements the HealthBucket interface.
 */
export function instanceOfHealthBucket(value: object): value is HealthBucket {
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function HealthBucketFromJSON(json: any): HealthBucket {
    return HealthBucketFromJSONTyped(json, false);
}

export function HealthBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
        'total': json['total'],
        'start': (new Date(json['start'])),
    };
}

export function HealthBucketToJSON(value?: HealthBucket | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'error': value['error'],
        'total': value['total'],
        'start': ((value['start']).toISOString()),
    };
}

